import React from 'react'
import { optionedPackageVS } from 'services/validations/catalog/packages/optionedPackage'
import { OptionedProductPresetFields } from '../OptionedProductPresetFields'
import ProductPackageBaseFormProvider from '../ProductPackageBaseFormProvider'

const PhysicalPackageForm: React.FC = () => (
  <ProductPackageBaseFormProvider
    entity="physicals"
    validationSchema={optionedPackageVS}
    presetInputFields={<OptionedProductPresetFields />}
  />
)

export default PhysicalPackageForm
